module.exports = __webpack_public_path__ + "/images/cover-multi-hero.9da4beb.png";